<template>
	<div class="container m-t-2">

		<transition-group name="fade-items" tag="div" class="row" @before-leave="beforeLeave">
			<div class="m-b-4 col-xs-12 col-sm-6 col-sm-4 col-md-3 col-xl-2" data-testid="trainerBio" v-for="instructor in instructors" :key="instructor.profilePath">
				<div class="embed-responsive bio-photo-border" style="padding-bottom: 120%;">
					<img class="embed-responsive-item" :src="instructor.imageUrl" data-testid="instructorImage" alt="" style="bottom: auto; max-width: 170%; width: 170%; height: auto; top: -2%; left: -35%; right: -35%;"/>
				</div>

				<h2 class="h5 m-t-1">{{ instructor.name }}</h2>
				<a class="d-block small m-b-2" :href="instructor.bioUrl" data-testid="aboutMeLnk">About Me</a>
				<button class="btn btn-primary btn-sm btn-block" data-testid="scheduleSessionBtn" @click="scheduleSession(instructor)" :disabled="!(selectedServiceSessions > 0)">Schedule Session</button>
			</div>
		</transition-group>

	</div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'BioSub',
	props: {
		instructors: {
			default: null,
			type: Array
		},
		selectedServiceSessions: {
			type: Number,
			default: 0
		}
	},
	methods: {
		scheduleSession(instructor) {
			this.$emit('scheduleSessionWith', instructor.name);
		},
		beforeLeave(el) {
			const { marginLeft, marginTop, width, height } = window.getComputedStyle(el);
			el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`;
			el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`;
			el.style.width = width;
			el.style.height = height;
		}
	}
});
</script>

<style scoped lang="scss">
.bio-photo-border {
	border: solid 1px $gray-10;
}
</style>
